import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import globalTable from '@/mixins/components/table';
import { dynamicSetup } from '@/mixins/dynamic-setup';
import dropsLoader from '@/mixins/components/drops-loader';
import StoreManageOrder from './manage-order';

export default Vue.component('data-product-store-orders', {
  template: require('./template.html'),
  name: 'data-product-store-orders',
  mixins: [dynamicSetup],
  computed: {
    ...mapGetters([
      'currentSite',
      'storeOrdersLoaded',
      'storeOrders',
      'activeSiteType',
    ]),
    storeData() {
      return this.currentSite.dynamic.products;
    },
    statuses() {
      return [
        'shipped',
        'fulfilled',
        'picked up',
        'pending',
        'exchanged',
        'cancelled',
        'refunded & no return',
        'refunded & returned',
      ];
    },
    checkedFilters() {
      return _.map(this.filters, (value, filter) => filter).filter(f => this.filters[f]);
    },
    orders() {
      return this.storeOrders.map((order) => {
        const total = parseFloat(order.pricing.total).toFixed(2);
        order.total = `${this.htmlDecode(order.pricing.symbol)}${total} ${_.upperCase(order.pricing.type)}`;
        let itemCount = 0;
        const items = [];
        order.cartItems.forEach((item) => {
          itemCount += parseInt(item.count, 10);
          if (!items.includes(item.name)) {
            items.push(item.name);
          }
        });
        order.items = items.join(', ');
        order.customer = `${order.firstName} ${order.lastName}`;
        order.itemCount = itemCount.toString();
        return order;
      }).filter(order => this.checkedFilters.includes(order.status));
    },
  },
  components: {
    globalTable,
    StoreManageOrder,
    dropsLoader,
  },
  data() {
    return {
      activeOrder: null,
      loading: false,
      loadError: false,
      showFilters: false,
      filters: {},
    };
  },
  props: ['props'],
  created() {
    if (this.noDynamicData(this.activeSiteType)) {
      this.dynamicSetup(this.activeSiteType);
    }
    this.setFilters();
    if (!this.storeOrdersLoaded) {
      this.getSiteOrders();
    }
  },
  methods: {
    async getSiteOrders() {
      this.loading = true;
      this.loadError = false;
      try {
        const orders = await this.$lightning([{
          name: 'getSiteOrders',
          payload: {
            siteId: this.currentSite._id,
          },
        }]);
        this.$log.info('Orders: ', orders);
        this.$store.dispatch('setStoreOrders', orders);
        this.$store.dispatch('setOrdersLoaded', true);
      } catch (e) {
        const message = e.message || e;
        this.$log.error(message);
        this.loadError = message;
        await this._reportError({
          error: message,
          fn: 'getSiteOrders',
        });
      } finally {
        this.loading = false;
      }
    },
    viewOrder(item) {
      this.activeOrder = item;
    },
    htmlDecode(input) {
      const e = document.createElement('div');
      e.innerHTML = input;
      return e.childNodes.length === 0 ? '' : e.childNodes[0].nodeValue;
    },
    setFilters() {
      _.forEach(this.statuses, (status) => {
        this.$set(this.filters, status, true);
      });
    },
    getColors({ key, value }) {
      const isStatus = key === 'status';
      return {
        'editorUi-orderStatus-orange': isStatus && value === 'pending',
        'editorUi-orderStatus-purple': isStatus && value === 'cancelled',
        'editorUi-orderStatus-green': isStatus && (value === 'fulfilled' || value === 'picked up'),
        'editorUi-orderStatus-brown': isStatus && value === 'shipped',
        'editorUi-orderStatus-blue': isStatus && value === 'exchanged',
        'editorUi-orderStatus-red': isStatus && value === 'refunded & no return',
        'editorUi-orderStatus-yellow': isStatus && value === 'refunded & returned',
      };
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/page/top-control-bar/dynamic-data/store/orders/index.js